// components/contribute/Step3AdditionalInfo.js
import './StepComponents.css'

function Step3AdditionalInfo ({ formData, onChange, disabled }) {
  return (
    <div className='step-content'>
      <div className='step-header'>
        <h2>Zusätzliche Informationen</h2>
        <p>
          Diese Angaben helfen anderen Technikern, die Komplexität einzuschätzen
        </p>
      </div>

      <div className='form-section'>
        <div className='form-row'>
          <div className='form-group'>
            <label>Schwierigkeitsgrad</label>
            <select
              value={formData.difficulty}
              onChange={e => onChange('difficulty', e.target.value)}
              disabled={disabled}
            >
              <option value='easy'>Einfach - Für Anfänger geeignet</option>
              <option value='medium'>Mittel - Erfahrung erforderlich</option>
              <option value='hard'>Schwierig - Für Experten</option>
            </select>
          </div>

          <div className='form-group'>
            <label>Geschätzte Dauer</label>
            <input
              type='text'
              value={formData.estimatedTime}
              onChange={e => onChange('estimatedTime', e.target.value)}
              placeholder='z.B. 15min, 1h, 2-3h'
              disabled={disabled}
            />
          </div>
        </div>

        <div className='form-group'>
          <label>Benötigte Werkzeuge</label>
          <input
            type='text'
            value={formData.toolsRequired}
            onChange={e => onChange('toolsRequired', e.target.value)}
            placeholder='z.B. Schraubendreher, Multimeter (kommagetrennt)'
            disabled={disabled}
          />
          <div className='help-text'>
            Hilft Technikern, sich vorzubereiten bevor sie mit der Reparatur
            beginnen
          </div>
        </div>

        <div className='info-box'>
          <strong>Alle Felder auf dieser Seite sind optional</strong>
          <p>Sie können diesen Schritt überspringen, wenn Sie möchten.</p>
        </div>
      </div>
    </div>
  )
}

export default Step3AdditionalInfo
